import { render, staticRenderFns } from "./DiscountDetail.vue?vue&type=template&id=e028b474&"
import script from "./DiscountDetail.vue?vue&type=script&lang=ts&"
export * from "./DiscountDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports